import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { subjects_all, Grade } from "components/State&Subject/";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  },
  formControl: {
    minWidth: "100%"
  },
  mBottom: {
    marginBottom: "20px"
  },
  mTop: {
    marginTop: "5px"
  }
}));

export default function OlevelCertificate() {
  const classes = useStyles();

  const [myClass, setMyClass] = React.useState("");
  const [subject1, setSubject1] = React.useState("");
  const [subject2, setSubject2] = React.useState("");
  const [subject3, setSubject3] = React.useState("");
  const [subject4, setSubject4] = React.useState("");
  const [subject5, setSubject5] = React.useState("");
  const [subject6, setSubject6] = React.useState("");
  const [subject7, setSubject7] = React.useState("");
  const [subject8, setSubject8] = React.useState("");
  const [subject9, setSubject9] = React.useState("");

  // Setting the state for Grade

  const [grade1, setGrade1] = React.useState("");
  const [grade2, setGrade2] = React.useState("");
  const [grade3, setGrade3] = React.useState("");
  const [grade4, setGrade4] = React.useState("");
  const [grade5, setGrade5] = React.useState("");
  const [grade6, setGrade6] = React.useState("");
  const [grade7, setGrade7] = React.useState("");
  const [grade8, setGrade8] = React.useState("");
  const [grade9, setGrade9] = React.useState("");

  const handleMyClassChange = event => {
    setMyClass(event.target.value);
  };

  const handleSubject1 = event => {
    setSubject1(event.target.value);
  };

  const handleSubject2 = event => {
    setSubject2(event.target.value);
  };

  const handleSubject3 = event => {
    setSubject3(event.target.value);
  };

  const handleSubject4 = event => {
    setSubject4(event.target.value);
  };

  const handleSubject5 = event => {
    setSubject5(event.target.value);
  };

  const handleSubject6 = event => {
    setSubject6(event.target.value);
  };

  const handleSubject7 = event => {
    setSubject7(event.target.value);
  };

  const handleSubject8 = event => {
    setSubject8(event.target.value);
  };

  const handleSubject9 = event => {
    setSubject9(event.target.value);
  };

  const handleGrade1 = event => {
    setGrade1(event.target.value);
  }

  // Function to change class based on the class selected
  // const changeClass = () => {
  //   switch (myClass) {
  //     case "SCIENCE":
  //       return subjects_sciences.map((subject, i) => (
  //         <MenuItem value={subject.name} key={i}>
  //           {subject.name}
  //         </MenuItem>
  //       ));
  //     case "COMMERCIAL":
  //       return subjects_commercial.map((subject, i) => (
  //         <MenuItem value={subject.name} key={i}>
  //           {subject.name}
  //         </MenuItem>
  //       ));
  //     default:
  //       return subjects_arts.map((subject, i) => (
  //         <MenuItem value={subject.name} key={i}>
  //           {subject.name}
  //         </MenuItem>
  //       ));
  //   }
  // };

  const changeClass = () => {
    return subjects_all.map((subject, i) => (
      <MenuItem value={subject.name} key={i}>
        {subject.name}
      </MenuItem>
    ));
  };

  const changeGrade = () => {
    return Grade.map((grade, i) => (
      <MenuItem value={grade.name} key={i}>
        {grade.name}
      </MenuItem>
    ));
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} className={classes.mTop}>
              <Typography>
                HOW MANY TIMES HAVE YOU TAKEN S. S. C. E (W.A.E.C.), G.C.E. OR
                EQUIVALENT?
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="ttaken"
                label="Number of Times sitted"
                type="number"
                id="ttaken"
                autoComplete="times taken"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="ttaken"
                label="Years E.g 1990/1991"
                type="text"
                id="yeartaken"
                autoComplete="times taken"
              />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.mTop}>
              <Typography>
                List all subjects and Grades in your Certificates
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject1}
                  onChange={handleSubject1}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject2}
                  onChange={handleSubject2}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject3}
                  onChange={handleSubject3}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject4}
                  onChange={handleSubject4}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject5}
                  onChange={handleSubject5}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject6}
                  onChange={handleSubject6}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject7}
                  onChange={handleSubject7}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject8}
                  onChange={handleSubject8}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Subject</InputLabel>
                <Select
                  fullWidth
                  id=""
                  value={subject9}
                  onChange={handleSubject9}
                  label="Age"
                >
                  {changeClass()}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">Grade</InputLabel>
                <Select
                  fullWidth
                  id="grade1"
                  value={grade1}
                  onChange={handleGrade1}
                  label="Grade"
                >
                  {changeGrade()}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="parent-guardian"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="upload-document"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
